export * from './fs';
export * from './wt';
export * from './encoder/encoder';

import {EditorLayer, EditorProject, Folder, Media} from '../types';

import {getById, getFolderContent, evolu} from './db';
import {cast} from '@evolu/common';
import {shareFileToWT} from './wt';
import {FolderPreviewContentType} from '../hooks/useFolders';
import {getFileOpfs} from './fs';

export const recursiveShare = async (
  media: FolderPreviewContentType,
): Promise<void> => {
  if ((media as Media).isDownloaded) {
    try {
      shareFileToWT(media.id, media.folderId);
      // return;
    } catch (err) {
      // console.error("shareFileToWT", err)
    }
  }
  if (
    (media as Folder).isFolder ||
    (media as EditorProject).isEditorProject ||
    (media as EditorLayer).isEditorLayer
  ) {
    const innerContent: (Media | Folder)[] = await getFolderContent(
      media.id,
    );
    await Promise.all(innerContent.map(recursiveShare));
    return;
  }
  return undefined;
};

export const shareFolder = async (folder: Folder) => {
  const content: (Media | Folder)[] = await getFolderContent(
    folder.id,
  );
  // for (let n = 0; n < content.length; n++) {
  // const contentItem =
  // await recursiveShare(content[n]);
  // const shared = (await Promise.all(content.map(recursiveShare))).flat().filter((i)=>i)
  // }
};
export const startUpMediaSharing = async () => {
  try {
    // await new Promise(res=>setTimeout(()=>res(), 20000))
    const query = (await evolu).createQuery(db =>
      db
        .selectFrom('item')
        .selectAll()
        .where('isFolder', '=', cast(true))
        .where('mnemonic', 'is not', null)
        .orderBy('createdAt', 'desc'),
    );

    // const sharedFolders: Folder[] = (
    //   await (await evolu).loadQuery(query)
    // )?.rows?.map(i => i.item);
    // console.info("sharedFolders", sharedFolders)
    // for (let i = 0; i < sharedFolders.length; i++) {
    //   const folder = sharedFolders[i];
    // await shareFolder(folder);
    // return shared;
    // }
    // const sharedFiles = (
    //   await Promise.all(
    //     sharedFolders.map(async folder => {
    //       const content: (Media | Folder)[] = await getFolderContent(
    //         folder.id,
    //       );
    //       const shared = (
    //         await Promise.all(content.map(recursiveShare))
    //       )
    //         .flat()
    //         .filter(i => i);
    //       return shared;
    //     }),
    //   )
    // ).flat();
    // console.info('sharedFiles', sharedFiles);
  } catch (err) {
    console.error('startUpMediaSharing error', err);
  }
};

export const getMediaAndEnq = async (
  mediaId: string,
  filename: string,
) => {
  const media: Media = (await getById(mediaId)) as any;
  console.info('playing media', media);
  if (media.extractor === 'local') {
    media.url = (await getFileOpfs(media)) as string;
  }
  return enqMedia(media, filename);
};

export const enqMedia = async (media: Media, filename: string) => {
  return playMediaLink(media.url, media.currentPosition, filename);
};
